<app-header></app-header>

<div class="flex mt-2">
  <app-sidebar optionMenu="12"></app-sidebar>

  <div class="p-6 bg-gray-100 min-h-screen w-full">
    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xl font-semibold text-gray-800">Video</h2>
      <button [routerLink]="['/form-video']"
        class="flex items-center gap-2 px-4 py-2 text-white bg-purple-purple6 rounded-lg hover:bg-purple-800">
        + Crear bloque video
      </button>
    </div>

    <!-- Barra de búsqueda y filtro -->
    <div class="flex items-center justify-between bg-white rounded-lg p-4 mb-8 shadow-sm">
      <div class="flex items-center w-1/2">
        <input type="text" placeholder="Buscar por nombre o tag" [(ngModel)]="terminoBusqueda" (input)="filtrar()"
          class="w-[80%] px-4 py-4 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
          
      </div>

      <div class="flex items-center gap-4">
        <span class="text-sm font-medium" [ngClass]="estado === 'activo' ? 'text-purple-purple6' : 'text-gray-600'">Activos</span>
        <label class="relative inline-flex items-center cursor-pointer">
          <input 
            type="checkbox" 
            class="sr-only peer" 
            [checked]="estado === 'inactivo'" 
            (change)="cambiarEstadoDesdeEvento($event)">
          <div
            class="w-11 h-6 bg-gray-300 rounded-full peer after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full">
          </div>
        </label>
        <span class="text-sm font-medium" [ngClass]="estado === 'inactivo' ? 'text-purple-purple6' : 'text-gray-600'">Inactivos</span>
      </div>
      
    </div>

    <!-- Grid de módulos -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      <div *ngFor="let video of videosFiltrados" class="bg-white rounded-xl shadow-md flex flex-col">

        <!-- Contenedor de video -->
        <div class="relative w-full pt-[56.25%] overflow-hidden rounded-t-xl"> <!-- 16:9 ratio -->
          <iframe class="absolute top-0 left-0 w-full h-full" [src]="extraerSrc(video.embebido) | safeUrl"
            frameborder="0" allowfullscreen>
          </iframe>
        </div>

        <!-- Texto -->
        <div class="p-4">
          <h3 class="text-base font-semibold text-gray-800 line-clamp-2">{{ video.titulo }}</h3>
          <span class="inline-block mt-2 px-2 py-1 text-xs rounded"
            [ngClass]="video.estado === 'activo' ? 'text-[#23A9A1] bg-[#D5F6F4]' : 'text-[#F20066] bg-[#FFBDD8]'">
            {{ video.estado }}
          </span>

          <div class="flex items-center justify-between text-gray-500 text-sm mt-3 relative">
            <span>{{ video.created_at | date:'dd/MM/yyyy' }}</span>

            <!-- Contenedor menú -->
            <div class="relative">
              <!-- Botón de los 3 puntos -->
              <button (click)="toggleMenu(video.id)" class="p-1 rounded-full hover:bg-gray-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 6v.01M12 12v.01M12 18v.01" />
                </svg>
              </button>
            
              <!-- Dropdown -->
              <div *ngIf="menuAbiertoId === video.id"
                class="absolute right-0 mt-2 flex w-[112px] h-[52px] px-[6px] py-[10px] flex-col justify-center items-center shrink-0 rounded-md bg-white/50 shadow-[0_0_1px_0_rgba(24,24,24,0.40),0_0_1.5px_0_rgba(24,24,24,0.30),0_7px_22px_0_rgba(24,24,24,0.25)] backdrop-blur-[40px] z-10">
                
                <!-- Editar -->
                <button (click)="editVideoBlock(video.id)"
                  class="relative group flex items-center justify-between w-full h-7 px-2 mb-1 rounded hover:bg-[#23A9A1]">
                  <span class="text-gray-700 group-hover:text-white text-base font-medium leading-none">Editar</span>

                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M13.0007 6.99866C12.8238 6.99866 12.6543 7.0689 12.5292 7.19392C12.4042 7.31894 12.334 7.48851 12.334 7.66532V11.6653C12.334 11.8421 12.2637 12.0117 12.1387 12.1367C12.0137 12.2618 11.8441 12.332 11.6673 12.332H2.33398C2.15717 12.332 1.9876 12.2618 1.86258 12.1367C1.73756 12.0117 1.66732 11.8421 1.66732 11.6653V2.33199C1.66732 2.15518 1.73756 1.98561 1.86258 1.86059C1.9876 1.73556 2.15717 1.66532 2.33398 1.66532H6.33398C6.5108 1.66532 6.68036 1.59509 6.80539 1.47006C6.93041 1.34504 7.00065 1.17547 7.00065 0.998657C7.00065 0.821846 6.93041 0.652277 6.80539 0.527253C6.68036 0.402228 6.5108 0.331991 6.33398 0.331991H2.33398C1.80355 0.331991 1.29484 0.542704 0.919771 0.917777C0.544698 1.29285 0.333984 1.80156 0.333984 2.33199V11.6653C0.333984 12.1958 0.544698 12.7045 0.919771 13.0795C1.29484 13.4546 1.80355 13.6653 2.33398 13.6653H11.6673C12.1978 13.6653 12.7065 13.4546 13.0815 13.0795C13.4566 12.7045 13.6673 12.1958 13.6673 11.6653V7.66532C13.6673 7.48851 13.5971 7.31894 13.4721 7.19392C13.347 7.0689 13.1775 6.99866 13.0007 6.99866ZM3.00065 7.50532V10.332C3.00065 10.5088 3.07089 10.6784 3.19591 10.8034C3.32094 10.9284 3.49051 10.9987 3.66732 10.9987H6.49398C6.58172 10.9992 6.6687 10.9823 6.74992 10.9492C6.83115 10.916 6.90502 10.8671 6.96732 10.8053L11.5807 6.18532L13.474 4.33199C13.5365 4.27002 13.5861 4.19628 13.6199 4.11504C13.6538 4.0338 13.6712 3.94667 13.6712 3.85866C13.6712 3.77065 13.6538 3.68351 13.6199 3.60227C13.5861 3.52103 13.5365 3.4473 13.474 3.38532L10.6473 0.525324C10.5853 0.462838 10.5116 0.413242 10.4304 0.379396C10.3491 0.34555 10.262 0.328125 10.174 0.328125C10.086 0.328125 9.99884 0.34555 9.9176 0.379396C9.83636 0.413242 9.76263 0.462838 9.70065 0.525324L7.82065 2.41199L3.19398 7.03199C3.1322 7.09428 3.08331 7.16816 3.05014 7.24939C3.01696 7.33061 3.00014 7.41759 3.00065 7.50532ZM10.174 1.93866L12.0607 3.82532L11.114 4.77199L9.22732 2.88532L10.174 1.93866ZM4.33398 7.77866L8.28732 3.82532L10.174 5.71199L6.22065 9.66532H4.33398V7.77866Z" class="fill-gray-500 group-hover:fill-white"/>
                  </svg>
                </button>

                <!-- Eliminar -->
                <button (click)="confirmarEliminar(video)"
                  class="group flex items-center justify-between w-full h-7 px-2 rounded hover:bg-[#F20066]">
                  <span class="text-gray-700 group-hover:text-white text-base font-medium leading-none">Eliminar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none"
                    class="ml-1">
                    <path
                      d="M7.27255 5.08949V11.6349H5.818V5.08949H7.27255ZM8.7271 5.08949H10.1816V11.6349H8.7271V5.08949ZM5.818 1.45312H10.1816V2.1804H13.818V3.63494H13.0907V13.8168H12.3635V14.544H3.63619V13.8168H2.90891V3.63494H2.18164V2.1804H5.818V1.45312ZM4.36346 3.63494V13.0895H11.6362V3.63494H4.36346Z"
                      class="fill-gray-500 group-hover:fill-white" />
                  </svg>
                </button>
              </div>
            </div>
            
          </div>

        </div>
      </div>
    </div>


    <!-- Botón Más notas -->
    <div class="flex justify-center" *ngIf="hayMas">
      <button (click)="cargarVideos()" class="px-6 py-2 text-white bg-purple-purple6 rounded-lg hover:bg-purple-800"
        [disabled]="cargando">
        {{ cargando ? 'Cargando...' : 'Más notas' }}
      </button>
    </div>
  </div>
</div>